import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import { getDatabase, ref, set } from "firebase/database";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDYmpIMyq7XuqOXwoCY1qQEUTwrrZRNhi0",
  authDomain: "higgstyping.firebaseapp.com",
  projectId: "higgstyping",
  storageBucket: "higgstyping.appspot.com",
  messagingSenderId: "293051964000",
  appId: "1:293051964000:web:099257d44a9ed6b850c105",
  measurementId: "G-62QJYM65W2",
  databaseURL:
    "https://higgstyping-default-rtdb.asia-southeast1.firebasedatabase.app",
});

const db = firebaseApp.firestore();
const auth = firebase.auth();

// auth.onAuthStateChanged(async (user) => {
//   if (user) {
//       var userDoc = await firebase
//         .firestore()
//         .collection("users")
//         .doc(user.uid)
//         .get();
//       if (!userDoc.exists) {
//         await userDoc.ref.set({
//           screen_name: user.uid,
//           display_name: localStorage.getItem("display_name"),
//           clear_stage: Number(localStorage.getItem("clear_stage")),
//           totalScore: Number(localStorage.getItem("totalScore")),
//           bestTotalScore: Number(localStorage.getItem("bestTotalScore")),
//           todayTotalScore: Number(localStorage.getItem("todayTotalScore")),
//           bestKpm: Number(localStorage.getItem("bestKpm")),
//           bestKps: Number(localStorage.getItem("bestKps")),
//           bestScore: Number(localStorage.getItem("bestScore")),
//           lastUpdate: firebase.firestore.FieldValue.serverTimestamp(),
//           photoURL: Number(localStorage.getItem("photoURL")),
//           created_at: firebase.firestore.FieldValue.serverTimestamp(),
//         });
//       }
//   } else {
//     if (localStorage.getItem("isLogin") != "true") {
//       await auth.signInAnonymously();
//       localStorage.setItem("keyboardDisplay", "inline");
//       localStorage.setItem("theme", "Light");
//       localStorage.setItem("audioSize", 50);
//       localStorage.setItem("isLogin", "true");
//       localStorage.setItem("audioType", "type1");
//       localStorage.setItem("clear_stage", 0);
//       localStorage.setItem("display_name", "名無し");
//       localStorage.setItem("photoURL", "");
//       localStorage.setItem("screen_name", auth.currentUser.uid);
//       localStorage.setItem("totalScore", 0);
//       localStorage.setItem("bestTotalScore", 0);
//       localStorage.setItem("todayTotalScore", 0);
//       localStorage.setItem("bestKpm", 0);
//       localStorage.setItem("bestKps", 0);
//       localStorage.setItem("bestScore", 0);
//       window.location.href = "/";
//     } else {
//       setTimeout(async () => {
//         if (localStorage.getItem("isLogin") == "true") {
//           await auth.signInAnonymously();
//           localStorage.setItem("keyboardDisplay", "inline");
//           localStorage.setItem("theme", "Light");
//           localStorage.setItem("audioSize", 50);
//           localStorage.setItem("isLogin", "true");
//           localStorage.setItem("audioType", "type1");
//           localStorage.setItem("clear_stage", 0);
//           localStorage.setItem("display_name", "名無し");
//           localStorage.setItem("photoURL", "");
//           localStorage.setItem("screen_name", auth.currentUser.uid);
//           localStorage.setItem("totalScore", 0);
//           localStorage.setItem("bestTotalScore", 0);
//           localStorage.setItem("todayTotalScore", 0);
//           localStorage.setItem("bestKpm", 0);
//           localStorage.setItem("bestKps", 0);
//           localStorage.setItem("bestScore", 0);
//           window.location.href = "/";
//         }
//       }, 8000);
//     }
//   }
// });

// auth.onAuthStateChanged(async (user) => {
//   if (user) {
//     if (!user.isAnonymous) {
//       const users = db.collection("users").doc(user.uid);
//       const docs = await users.get();
//       let userData = docs.data();
//       if (localStorage.getItem("isLogin") != "true") {
//         localStorage.setItem("keyboardDisplay", "inline");
//         localStorage.setItem("theme", "Light");
//         localStorage.setItem("audioSize", 50);
//         localStorage.setItem("isLogin", "true");
//         localStorage.setItem("audioType", "type1");
//         localStorage.setItem(
//           "lastUpdate",
//           userData.lastUpdate.toDate().getDate()
//         );
//       }
//       let lastUp = localStorage.getItem("lastUpdate");
//       let nowUp;
//       var userDoc = await firebase
//         .firestore()
//         .collection("users")
//         .doc(user.uid)
//         .get();
//       if (userDoc.exists) {
//         await userDoc.ref.update({
//           lastUpdate: firebase.firestore.FieldValue.serverTimestamp(),
//         });
//       }
//       localStorage.setItem("clear_stage", userData.clear_stage);
//       localStorage.setItem("display_name", userData.display_name);
//       localStorage.setItem("photoURL", userData.photoURL);
//       localStorage.setItem("screen_name", userData.screen_name);
//       localStorage.setItem("totalScore", userData.totalScore);
//       localStorage.setItem("bestTotalScore", userData.bestTotalScore);
//       localStorage.setItem("todayTotalScore", userData.todayTotalScore);
//       localStorage.setItem("bestKpm", userData.bestKpm);
//       localStorage.setItem("bestKps", userData.bestKps);
//       localStorage.setItem("bestScore", userData.bestScore);
//       localStorage.setItem(
//         "lastUpdate",
//         userData.lastUpdate.toDate().getDate()
//       );
//       console.log(userData);
//       nowUp = localStorage.getItem("lastUpdate");
//       if (nowUp != lastUp) {
//         localStorage.setItem("todayTotalScore", 0);
//         await userDoc.ref.update({
//           todayTotalScore: 0,
//         });
//       }
//     } else {
//       let lastTime = Number(localStorage.getItem("lastUpdate"));
//       let nowTime = firebase.firestore.Timestamp.now().toDate().getDate();
//       if (nowTime != lastTime) {
//         localStorage.getItem("todayTotalScore", 0);
//       }
//       localStorage.setItem("lastUpdate", nowTime);
//     }
//   }
// });

export { db, auth };
